import { toPng } from 'html-to-image';

/** Rasterize the on-screen share card to a PNG blob. */
export async function captureShareCardImage(element) {
  if (!element) return null;
  const dataUrl = await toPng(element, {
    cacheBust: true,
    pixelRatio: Math.min(3, window.devicePixelRatio || 2),
    backgroundColor: '#ffffff',
  });
  const response = await fetch(dataUrl);
  return response.blob();
}

/**
 * Share or copy the image. Returns how it was delivered, or null on failure.
 * Falls back: native file share → clipboard image → download.
 */
export async function deliverShareImage(blob, { title = 'Langle', caption = 'langshazam.com/langle' } = {}) {
  const file = new File([blob], 'langle.png', { type: 'image/png' });

  if (navigator.share) {
    try {
      const payload = { files: [file], title, text: caption };
      if (!navigator.canShare || navigator.canShare(payload)) {
        await navigator.share(payload);
        return 'shared';
      }
    } catch (err) {
      if (err?.name === 'AbortError') return 'aborted';
    }
  }

  if (navigator.clipboard?.write && typeof ClipboardItem !== 'undefined') {
    try {
      await navigator.clipboard.write([new ClipboardItem({ 'image/png': blob })]);
      return 'copied';
    } catch { /* fall through */ }
  }

  const url = URL.createObjectURL(blob);
  try {
    const link = document.createElement('a');
    link.href = url;
    link.download = 'langle.png';
    link.click();
    return 'downloaded';
  } finally {
    URL.revokeObjectURL(url);
  }
}
